import api from "./index";

export interface DocumentTemplatesListParams {
  title?: string;
  companyId?: string;
  ownerId?: string;
  type?: string;
  sort?: "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  offset?: number;
  limit?: number;
  options?: any;
}

export default (params: DocumentTemplatesListParams) => {
  return api.DocTemplateApi.list(
    params.title,
    params.companyId,
    params.ownerId,
    params.type,
    params.sort,
    params.order,
    params.offset,
    params.limit,
    params.options
  );
};
